import { useState } from 'react'
import logoAvtodor from 'images/branding/avtodor/logo.png'
import Modal from 'react-modal'
import { COMPANY, CompanyName } from 'config'
import { branding } from 'utils/branding'
import style from './AvtodorLayout.module.css'

const Footer = () => {
  const [showModal, setShowModal] = useState(false)
  return COMPANY === CompanyName.AVTODOR ? (
    <>
      <div className={style.footerLinks}>
        <a href={'/policy'} target="_blank" rel="noreferrer" className={style.policyLink}>
          Политика конфиденциальности
        </a>
        <div className={style.footerLink} onClick={() => setShowModal(true)}>
          Помощь
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        closeTimeoutMS={200}
        className={style.modal}
        overlayClassName={style.overlay}
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
      >
        <img src={logoAvtodor} alt="logo" className={style.logoModal} />
        <p>
          При возникновении вопросов
          <br /> свяжитесь с нами!{' '}
        </p>
        <p>
          <a href={`mailto:${branding.getSupportEmail()}`}>{branding.getSupportEmail()}</a>
        </p>
      </Modal>
    </>
  ) : null
}

export default Footer
